/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { FaTimes } from '../../../../../util/reactIcons';
import { CloseButton, StyledCustomInputBox } from './styled/StyledCustomInputBox';

export const CustomInputBox = ({ name, initialValue, label, inputType, handleOnChange, toggleShowInputBox }) => {
  const [inputValue, setInputValue] = useState(initialValue);

  return (
    <StyledCustomInputBox className={name}>
      <CloseButton onClick={() => toggleShowInputBox()}>
        <FaTimes size="1.3em" />
      </CloseButton>
      <span>{label}</span>
      <input
        type={inputType}
        value={inputValue}
        onChange={(e) => {
          handleOnChange(e);
          setInputValue(e.target.value);
        }}
      />
    </StyledCustomInputBox>
  );
};

export default CustomInputBox;
